import { type z } from 'zod';
import { object as __eliadmin_zod_0, number as __eliadmin_zod_1, string as __eliadmin_zod_2 } from 'zod';
import { ensureZodDefaults as __eliadmin_zod_defaults } from '@eliadmin/core/src/build/zod-defaults';
__eliadmin_zod_defaults();

import type { FormValidationMessages } from '@eliadmin/core/src/hooks/use-form-validation-messages';

/** Stars of the overall rating (the API takes 1–5). */
export const RATING_STEPS = [1, 2, 3, 4, 5] as const;

/** Length limit of the review text – the counter „0 / 1 000“ of Figma 154:4535. */
export const REVIEW_MAX_LENGTH = 1000;

/**
 * Body of `POST /store/products/{slug}/write-review` as the core review dialog validates it. `rating`
 * is 0 until a star is chosen. The core `REVIEW_RATING_RANGE_VALIDATION_MESSAGE` points at a
 * dictionary entry that is not a rating message in this dictionary („Súvisiace produkty“), so a
 * missing rating says „required“ and the (unreachable from the stars) range uses the generic range text.
 */
export const reviewSchema = (messages: FormValidationMessages) =>
  __eliadmin_zod_0({
    rating: __eliadmin_zod_1()
      .int()
      .min(1, messages.REQUIRED_FIELD_VALIDATION_MESSAGE())
      .max(5, messages.NOT_IN_RANGE_VALIDATION_MESSAGE(1, 5)),
    review: __eliadmin_zod_2()
      .trim()
      .min(1, messages.CANT_BE_EMPTY_VALIDATION_MESSAGE())
      .max(REVIEW_MAX_LENGTH, messages.MAX_LENGTH_VALIDATION_MESSAGE(REVIEW_MAX_LENGTH)),
  });

export type ReviewValues = z.infer<ReturnType<typeof reviewSchema>>;

export const EMPTY_REVIEW: ReviewValues = { rating: 0, review: '' };
